import { render, staticRenderFns } from "./MealPlanDownloads.vue?vue&type=template&id=2e88110b&scoped=true"
import script from "./MealPlanDownloads.vue?vue&type=script&lang=js"
export * from "./MealPlanDownloads.vue?vue&type=script&lang=js"
import style0 from "./MealPlanDownloads.vue?vue&type=style&index=0&id=2e88110b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88110b",
  null
  
)

export default component.exports